import { ReactNode, useEffect, useState } from 'react'

import { Layout } from 'antd'

const { Sider } = Layout

export interface LayoutSidebarProps {
  children: ReactNode
}

export const LayoutSidebar = (props: LayoutSidebarProps) => {
  const { children } = props

  const [collapsed, setCollapsed] = useState(false)
  const [logo, setLogo] = useState<string>()
  const [padding, setPadding] = useState<number>(23)
  const [height, setHeight] = useState<number>(40)

  useEffect(() => {
    setLogo('/images/logo.sygo.200px.png')
  }, [])

  const handleOnCollapsed = () => {
    setCollapsed(!collapsed)

    if (collapsed) {
      setLogo('/images/logo.sygo.200px.png')
      setPadding(23)
      setHeight(40)
    } else {
      setLogo('/images/logo.sygo.300px-collapsed.png')
      setPadding(0)
      setHeight(30)
    }
  }

  return (
    <Sider
      theme="light"
      collapsible
      collapsed={collapsed}
      onCollapse={handleOnCollapsed}
      style={{
        marginTop: '64px'
      }}
    >
      <div
        style={{
          width: 80,
          textAlign: 'center',
          marginTop: 20,
          paddingLeft: padding
        }}
      >
        <img src={logo} height={height} alt="logo" />
      </div>
      {children}
    </Sider>
  )
}
